export const validateName = (name) => {
  if (!/[^a-zA-Z]/.test(name)) {
    return true;
  } else {
    return false;
  }
};

export const validateEmail = (email) => {
  const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  if (email && email.match(isValidEmail)) {
    return true;
  } else {
    return false;
  }
};

export const validatePassword = (password) => {
  const pattern = /^[A-Za-z]\w{7,14}$/;

  return !!password.match(pattern);
  // return password.length >= 8 ? true : false
};

export const ValidateMobileNumber = (mobileNumber) =>
  !!/^(0|91)?[6-9][0-9]{9}$/.test(mobileNumber);

export const encodeURL = (str) => btoa(str);

export const decodeURL = (str) => atob(str);

export const checkSpace = (input) => !!/^\s/.test(input);

export const encryptPhoneEmail = (messageInput, userEmail, userPhone, trimInput = true) => {
  // Provide default values for phone and email in case they are empty or null
  const defaultPhone = userPhone || '1234567890';  // Default phone number if null/empty
  const defaultEmail = userEmail || 'abc@gmail.com';  // Default email if null/empty
  
  let modifiedString = trimInput ? messageInput?.trim() : messageInput;
  const regexContainsNumber = /\d{7,15}/;
  const regexTestPhoneNumber = /^[+]{1}(?:[0-9\-\(\)\/\.]\s?){6,15}[0-9]{1}$/;
  const regexTestEmailAddress = /\S+@\S+\.\S+/;

  function replaceCallback(match) {
    // Replace each digit in the match with '*'
    return '*'.repeat(match.length);
  }

  const patterns = ["@", "gmail", ".com", ".in", "yahoo", "outlook", "ymail", "hotmail", "icloud", "aol", "@live", "protonmail", "zoho", "mail", "yandex", ".net", "btinternet"];
  const combinedPattern = patterns.map(pattern => pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
  const numeralsString = "one|two|three|four|five|six|seven|eight|nine|zero|1|2|3|4|5|6|7|8|9|0";

  const patternsToReplace = [
    { regex: regexContainsNumber, callback: replaceCallback },
    { regex: regexTestPhoneNumber, callback: replaceCallback },
    { regex: regexTestEmailAddress, callback: replaceCallback },
    { regex: new RegExp(defaultEmail, 'i'), callback: replaceCallback },
    { regex: new RegExp(defaultPhone, 'i'), callback: replaceCallback },
    { regex: new RegExp(`(?:\\b(?:${numeralsString})\\b\\s*){4,}\\b(?:${numeralsString})\\b`, 'gi'), callback: replaceCallback },
    { regex: new RegExp(combinedPattern, 'i'), callback: replaceCallback },
  ];

  while (true) {
    let matchFound = false;

    for (const { regex, callback } of patternsToReplace) {
      const matchRes = modifiedString.match(regex);
      if (matchRes) {
        modifiedString = modifiedString.replace(regex, callback);
        matchFound = true;
        break;
      }
    }

    if (!matchFound) {
      break;
    }
  }

  return modifiedString;
};

// export const encryptPhoneEmail = (messageInput, userEmail, userPhone, trimInput = true) => {
//   let modifiedString = trimInput ? messageInput?.trim() : messageInput
//   const regexContainsNumber = /\d{7,15}/;
//   const regexTestPhoneNumber = /^[+]{1}(?:[0-9\-\(\)\/\.]\s?){6,15}[0-9]{1}$/;
//   const regexTestEmailAddress = /\S+@\S+\.\S+/;

//   function replaceCallback(match) {
//     // Replace each digit in the match with '*'
//     return '*'.repeat(match.length);
//   }

//   const patterns = ["@", "gmail", ".com", ".in", "yahoo", "outlook", "ymail", "hotmail", "icloud", "aol", "@live", "protonmail", "zoho", "mail", "yandex", ".net", "btinternet"];
//   const combinedPattern = patterns.map(pattern => pattern.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|');
//   const numeralsString = "one|two|three|four|five|six|seven|eight|nine|zero|1|2|3|4|5|6|7|8|9|0"

//   const patternsToReplace = [
//     { regex: regexContainsNumber, callback: replaceCallback },
//     { regex: regexTestPhoneNumber, callback: replaceCallback },
//     { regex: regexTestEmailAddress, callback: replaceCallback },
//     { regex: new RegExp(userEmail ?? "@gmail.com", 'i'), callback: replaceCallback },
//     { regex: new RegExp(userPhone ?? "1234567890", 'i'), callback: replaceCallback },
//     { regex: new RegExp(`(?:\\b(?:${numeralsString})\\b\\s*){4,}\\b(?:${numeralsString})\\b`, 'gi'), callback: replaceCallback },
//     { regex: new RegExp(combinedPattern, 'i'), callback: replaceCallback },
//   ];

//   while (true) {
//     let matchFound = false;

//     for (const { regex, callback } of patternsToReplace) {
//       const matchRes = modifiedString.match(regex);
//       if (matchRes) {
//         modifiedString = modifiedString.replace(regex, callback);
//         matchFound = true;
//         break;
//       }
//     }

//     if (!matchFound) {
//       break;
//     }
//   }

//   return modifiedString
// }

export const guid = () => {
  const s4 = () =>
    Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);

  return `${s4() + s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
};

export const fetchGreetings = () => {
  const hour = new Date().getHours();
  const welcomeTypes = ["Good morning", "Good afternoon", "Good evening"];
  let welcomeText = "";

  if (hour < 12) welcomeText = welcomeTypes[0];
  else if (hour < 18) welcomeText = welcomeTypes[1];
  else welcomeText = welcomeTypes[2];

  return welcomeText;
};

export function forceNumberWithTwoDecimalPlacesAndLength(input, length) {
  const parsedInput = parseFloat(input).toFixed(2);
  if (parsedInput.length === length) {
    return Number(parsedInput);
  } else {
    return null;
  }
}

export function isObjectWithKey(variable, key) {
  return (
    typeof variable === "object" &&
    variable !== null &&
    variable.hasOwnProperty(key)
  );
}

export function isInteger(value) {
  return typeof value === "number" && Number.isInteger(value);
}

export function getObjectById(data, id) {
  const filterObj = data.filter((e) => e.id == id);
  return filterObj[0];
}
